import { useSelector } from 'react-redux'

import { ApplicationState } from 'redux/Stores/types'
import {
  selectGroupIdsForKeyMetric,
  selectKeyMetricIdsForGroup
} from 'redux/selectors/GroupKeyMetricLinker'

export const useGroupIdsForKeyMetric = (keyMetricId: string) => {
  return useSelector((state: ApplicationState) =>
    selectGroupIdsForKeyMetric(state, keyMetricId))
}

export const useKeyMetricIdsForGroup = (groupId: string) => {
  return useSelector((state: ApplicationState) =>
    selectKeyMetricIdsForGroup(state, groupId))
}
